var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-page--single"},[(_vm.storeObj !== null)?_c('contact-map',{attrs:{"storeObj":_vm.storeObj}}):_vm._e(),_vm._v(" "),(_vm.storeObj !== null)?_c('contact-info',{attrs:{"storeObj":_vm.storeObj}}):_vm._e(),_vm._v(" "),_c('contact-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }